import React from 'react';

const features = [
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
      </svg>
    ),
    title: 'Smart Shift Scheduling',
    desc: 'AI-powered shift assignment that considers availability, skills, and preferences. Auto-generate optimal rosters in seconds.',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
    ),
    title: 'Staff Management',
    desc: 'Complete employee profiles with roles, departments, certifications, and availability. Everything in one unified view.',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
      </svg>
    ),
    title: 'Real-time Attendance',
    desc: 'Track clock-ins, clock-outs, and breaks with geo-verified attendance. Instant visibility into who is where.',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>
      </svg>
    ),
    title: 'Leave Management',
    desc: 'Streamlined leave requests and approvals. Auto-calculate balances, handle policies, and prevent scheduling conflicts.',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 20V10"/><path d="M12 20V4"/><path d="M6 20v-6"/>
      </svg>
    ),
    title: 'Analytics & Reports',
    desc: 'Workforce insights with real-time dashboards. Track overtime, labor costs, coverage gaps, and productivity trends.',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
      </svg>
    ),
    title: 'Compliance & Security',
    desc: 'Role-based access, audit logs, and data encryption. Stay compliant with labor regulations and organizational policies.',
  },
];

function Features() {
  return (
    <section className="section section-gray" id="features">
      <div className="container">
        <div className="section-header">
          <div className="section-badge">Features</div>
          <h2 className="section-title">Everything You Need to Manage Your Workforce</h2>
          <p className="section-subtitle">
            From scheduling to compliance, 9works gives you the complete toolkit
            to run efficient, happy, and well-organized teams.
          </p>
        </div>
        <div className="features-grid">
          {features.map((f, i) => (
            <div className={`feature-card fade-in fade-in-delay-${i + 1}`} key={i}>
              <div className="feature-icon">{f.icon}</div>
              <h3 className="feature-title">{f.title}</h3>
              <p className="feature-desc">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;
